/*import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = ({
  isAuthenticated,
  redirectPath = '/auth/login',
  children,
}: {
  isAuthenticated: boolean;
  redirectPath?: string;
  children: React.ReactNode;
}) => {
  if (!isAuthenticated) {
    return <Navigate to={redirectPath} replace />;
  }

  return children ? children : <Outlet />;
};

export default ProtectedRoute;  */

import { Navigate, useLocation } from 'react-router-dom';

export const ProtectedRoute = ({
  isAuthenticated,
  children,
}: {
  isAuthenticated: string;
  children: React.ReactNode;
}) => {
  const { pathname, search } = useLocation();

  const lastPath = pathname + search;
  localStorage.setItem('lastPath', lastPath);

  return isAuthenticated === 'authenticated' ? (
    children
  ) : (
    <Navigate to="/auth/login" />
  );
};
